import { stringify } from 'qs';
import request from '@/services/request';
import { url } from '../service-utils';

/**
 * 栏目列表
 * @param params
 * @returns {Promise<void>}
 */
export async function getChannelList(params) {
  return request(`${url.url}/v3/channel/list?${stringify(params)}`);
}

/**
 * 栏目添加
 * @param params
 * @returns {Promise<void>}
 */
export async function iChannelAdd(params) {
  return request(`${url.url}/v3/channel/add`, {
    method: 'post',
    data: params,
  });
}

/**
 * 栏目修改
 * @param params
 * @returns {Promise<void>}
 */
export async function uChannelModify(params) {
  return request(`${url.url}/v3/channel/modify`, {
    method: 'post',
    data: params,
  });
}

/**
 * 栏目列表
 * @param params
 * @returns {Promise<void>}
 */
export async function channelDelete(params) {
  return request(`${url.url}/v3/channel/delete?${stringify(params)}`);
}

/**
 * 栏目上下移
 * @param params
 * @returns {Promise<void>}
 */
export async function moveChannel(params) {
  return request(`${url.url}/v3/channel/moveChannel?${stringify(params)}`);
}

/**
 * 栏目审批人
 * 页面：标签设置页
 * 前端：洪芳
 * 后端： 陈陈
 * @params
 */
export function modifyChannelAudit(params) {
  return request(`${url.url}/v3/channel/modifyChannelAudit`, {
    method: 'post',
    data: params,
  });
}
